function fnAboutHero(i, oSection ) {
	const endPoint = document.querySelector('.about-intro').offsetTop * 1.6
	
	gsap.to(oSection, {
		
		ease: 'none',
		scrollTrigger: {
			trigger: '.hero-about',
			pin: true,
			pinSpacing: false,
			scrub: true,
			start: 'top top',
			end: 'bottom top',
		}
	})
}